"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompaniesApi = exports.CompaniesApiFactory = exports.CompaniesApiFp = exports.CompaniesApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * CompaniesApi - axios parameter creator
 * @export
 */
const CompaniesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} ref
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyResourceDeleteCompany: (ref_1, ...args_1) => __awaiter(this, [ref_1, ...args_1], void 0, function* (ref, options = {}) {
            // verify required parameter 'ref' is not null or undefined
            (0, common_1.assertParamExists)('companyResourceDeleteCompany', 'ref', ref);
            const localVarPath = `/companies/{ref}/cleanup`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {InitialSetupRequest} [initialSetupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyResourceDoInitialSetup: (initialSetupRequest_1, ...args_2) => __awaiter(this, [initialSetupRequest_1, ...args_2], void 0, function* (initialSetupRequest, options = {}) {
            const localVarPath = `/companies/setup-company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(initialSetupRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyResourceGetCompanyByReference: (companyRef_1, ...args_3) => __awaiter(this, [companyRef_1, ...args_3], void 0, function* (companyRef, options = {}) {
            // verify required parameter 'companyRef' is not null or undefined
            (0, common_1.assertParamExists)('companyResourceGetCompanyByReference', 'companyRef', companyRef);
            const localVarPath = `/companies/{companyRef}/by-ref`
                .replace(`{${"companyRef"}}`, encodeURIComponent(String(companyRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CompaniesApiAxiosParamCreator = CompaniesApiAxiosParamCreator;
/**
 * CompaniesApi - functional programming interface
 * @export
 */
const CompaniesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CompaniesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} ref
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyResourceDeleteCompany(ref, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.companyResourceDeleteCompany(ref, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CompaniesApi.companyResourceDeleteCompany']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {InitialSetupRequest} [initialSetupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyResourceDoInitialSetup(initialSetupRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.companyResourceDoInitialSetup(initialSetupRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CompaniesApi.companyResourceDoInitialSetup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} companyRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyResourceGetCompanyByReference(companyRef, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.companyResourceGetCompanyByReference(companyRef, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CompaniesApi.companyResourceGetCompanyByReference']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.CompaniesApiFp = CompaniesApiFp;
/**
 * CompaniesApi - factory interface
 * @export
 */
const CompaniesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CompaniesApiFp)(configuration);
    return {
        /**
         *
         * @param {CompaniesApiCompanyResourceDeleteCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyResourceDeleteCompany(requestParameters, options) {
            return localVarFp.companyResourceDeleteCompany(requestParameters.ref, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CompaniesApiCompanyResourceDoInitialSetupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyResourceDoInitialSetup(requestParameters = {}, options) {
            return localVarFp.companyResourceDoInitialSetup(requestParameters.initialSetupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CompaniesApiCompanyResourceGetCompanyByReferenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyResourceGetCompanyByReference(requestParameters, options) {
            return localVarFp.companyResourceGetCompanyByReference(requestParameters.companyRef, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CompaniesApiFactory = CompaniesApiFactory;
/**
 * CompaniesApi - object-oriented interface
 * @export
 * @class CompaniesApi
 * @extends {BaseAPI}
 */
class CompaniesApi extends base_1.BaseAPI {
    /**
     *
     * @param {CompaniesApiCompanyResourceDeleteCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    companyResourceDeleteCompany(requestParameters, options) {
        return (0, exports.CompaniesApiFp)(this.configuration).companyResourceDeleteCompany(requestParameters.ref, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompaniesApiCompanyResourceDoInitialSetupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    companyResourceDoInitialSetup(requestParameters = {}, options) {
        return (0, exports.CompaniesApiFp)(this.configuration).companyResourceDoInitialSetup(requestParameters.initialSetupRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompaniesApiCompanyResourceGetCompanyByReferenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    companyResourceGetCompanyByReference(requestParameters, options) {
        return (0, exports.CompaniesApiFp)(this.configuration).companyResourceGetCompanyByReference(requestParameters.companyRef, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CompaniesApi = CompaniesApi;
//# sourceMappingURL=companies-api.js.map